import { signalStore, withState } from '@ngrx/signals';
import { initialApprovalState } from './approval.state';
import { withApprovalApiMethods } from './approval.methods.api';

export const ApprovalStore = signalStore(
    { providedIn: 'root' },
    withState(initialApprovalState),
    withApprovalApiMethods
);
